import React, { useCallback, useState, useEffect } from 'react';
import { clickGmoneypayDetailWeb, clickShareWeb } from 'common/appInterface';

const EtcTest = (props) => {

  const callback = useCallback(() => {
      props.setMain(true);
  }, [props]);

  const [screenId, setScreenId] = useState("");
  const [screenName, setScreenName] = useState("");
  const [jsonBody, setJsonBody] = useState("{\"merchantName\":\"할리스커피\",\"cardProductCodeName\":\"로얄체크카드\",\"salesKindName\":\"체크승인\",\"approvalDate\":\"20210124\",\"approvalTime\":\"151900\",\"cardApprovalAmount\":\"￦ 9,000\",\"salesAmount\":\"￦ 8,100\",\"taxAmount\":\"￦ 900\",\"serviceFee\":\"￦ 0\",\"merchantTelNo\":\"031-958-5034\",\"merchantAddress\":\"경기 파주시 적성면 어삼로 123-7\",\"merchantBizNo\":\"493-18-00125\",\"officerName\":\"홍길동\",\"businessName\":\"서양음식\",\"cardApprovalNo\":\"71808798\",\"cardNo\":\"V837\",\"slipPurchaseYn\":\"접수완료\"}");

  // clickShare_Web 처리 (WEB > APP)
  const clickShare = useCallback(() => {
    clickShareWeb(screenId, screenName, jsonBody);
  }, [screenId, screenName, jsonBody]);

  // clickGmoneypayDetail_Web 처리 (WEB > APP)
  const clickGmoneypayDetail = useCallback(() => {
    clickGmoneypayDetailWeb();
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callback);
    return () => document.removeEventListener("backpress", callback);
  }, [callback]);

  return (
    <div id="container">
      <section className="contents">
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">clickShare_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={screenId} onChange={(e) => setScreenId(e.target.value)} />
                  <span>screenId</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={screenName} onChange={(e) => setScreenName(e.target.value)} />
                  <span>screenName</span>
                </label>
              </div>
            </div>
            <div className="textareaBox mgb20"> 
              <label className="" style={{margin: "0 0 10px", position: "relative", display: "inline-block", width: "100%"}}>
                <textarea type="text" value={jsonBody} onChange={(e) => setJsonBody(e.target.value)} style={{marginTop: "10px", padding: "5px 10px"}} />
                <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>jsonBody</span>
              </label>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={clickShare}><span>clickShare_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">clickGmoneypayDetail_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="btnWrapTy01 mgb120">
              <button type="button" className="btnPrimaryTy01" onClick={clickGmoneypayDetail}><span>clickGmoneypayDetail_Web Call</span></button>
            </div>
          </div>
        </div>
      </section>
      <div className="btnArea">
        <div className="btnWrapTy01">
          <button type="button" className="btnPrimaryTy01 mgb60" onClick={callback}><span>메뉴복귀</span></button>
        </div>
      </div>
    </div>
  );
}

export default EtcTest;